import { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectAuthenticated } from "../selectors";
import * as agentApi from "./api";
import Composer from "./Composer";
import QuickActionPills from "./QuickActionPills";
import "./agent.css";

/**
 * Home-page entry to the agent. Sending creates the chat, then opens it with
 * the first message handed over so the conversation starts streaming there.
 */
export default function HomeAgentPrompt() {
    const authenticated = useSelector(selectAuthenticated);
    const navigate = useNavigate();
    const composerRef = useRef(null);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);

    const handleSend = async (content, files) => {
        if (authenticated === false) {
            navigate("/signin");
            return;
        }
        // Still checking the session: wait rather than bounce a signed-in user to sign-in.
        if (authenticated !== true) return;
        setBusy(true);
        setError(null);
        try {
            const session = await agentApi.createSession();
            navigate(`/agent/${session.id}`, { state: { initialMessage: { content, files } } });
        } catch (err) {
            setError(err.message || "Something went wrong. Please try again.");
            setBusy(false);
        }
    };

    return (
        <div className="tryon-agent mt-6">
            <Composer
                ref={composerRef}
                disabled={busy}
                error={error}
                onSend={handleSend}
                onDismissError={() => setError(null)}
            />
            <QuickActionPills className="mt-3" onPick={(prompt) => composerRef.current?.setText(prompt)} />
        </div>
    );
}
